import { Outlet } from "react-router";
import { useProposalsSocket } from "../../hooks/socket/use-proposals-socket";
import { useRequestExistingGroupListSocket } from "../../hooks/socket/use-request-existing-group-proposal";

export default function MarketingGMSLayout() {
    useProposalsSocket();
    useRequestExistingGroupListSocket()
    return <Outlet />;
}
